/**
 * Achata a árvore de erros do Formik (que acompanha o formato aninhado de
 * `values`) em uma lista plana de mensagens.
 *
 * Serve para dar feedback no submit quando o campo reprovado não está
 * renderizado — nesse caso o `ErrorLabel` do campo nunca aparece e o botão de
 * enviar simplesmente não faz nada.
 */
export const coletarMensagensErro = (errors: unknown): string[] => {
  if (!errors) return []
  if (typeof errors === 'string') return [errors]
  if (Array.isArray(errors)) return errors.flatMap(coletarMensagensErro)
  if (typeof errors === 'object')
    return Object.values(errors as Record<string, unknown>).flatMap(coletarMensagensErro)

  return []
}
